module.exports = __webpack_public_path__ + "static/images/permata.2qzEci_.svg";